import { PATHS } from '@/app/router/routes'

type DeliveryDestinationRow = {
  id: string
  delivery: { id: string } | null
}

/**
 * La ruta operable de una fila de Postventa.
 *
 * La fila se identifica por negociación (`neg_`), pero la vista de un acta existente exige el
 * `dlv_`. Cuando todavía no hay acta, el mismo `neg_` sí es correcto para iniciar el alta.
 */
export function deliveryDestination(row: DeliveryDestinationRow): string {
  return row.delivery
    ? PATHS.admin.deliveries.view(row.delivery.id)
    : PATHS.admin.deliveries.create(row.id)
}
